import { render, staticRenderFns } from "./settingitemDetails.vue?vue&type=template&id=603c91f9&scoped=true&"
import script from "./settingitemDetails.vue?vue&type=script&lang=js&"
export * from "./settingitemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603c91f9",
  null
  
)

export default component.exports